import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { Heart16, HeartStroke16 } from '@cian/ui-kit/icons';
import { IFavoriteButtonProps } from '../../../types/newbuilding/favorite';

export function FavoriteButton({ isFavorite, onClick, theme = 'fill_secondary' }: IFavoriteButtonProps) {
  const icon = isFavorite ? <Heart16 color="error_100" /> : <HeartStroke16 color="error_100" />;
  const label = isFavorite ? 'В избранном' : 'В избранное';

  return (
    <Button theme={theme} onClick={onClick} beforeIcon={icon} size="XS">
      {label}
    </Button>
  );
}
